<div class="fixed-bg"></div>
<div class="ohel-page">
  <div class="intro-screen">
    <div class="header-section">
      <div class="title-months">GIU/<br />AGO</div>
      <h1 class="title">OHEL<br />SUMMER<br />CAMP</h1>
      <div class="title-year">20<br />26</div>
    </div>
    <div class="subtitle">ISCRIZIONI APERTE ↓</div>
  </div>
  <br /><br /><br /><br /><br /><br />

  <!-- Turni -->
  <div class="content-section">
    <div class="program-card">
      <h2>Turni</h2>
      <div class="turni-grid">
        @for (t of turni; track t.value) {
          <div class="turno-card" (click)="scrollToForm()">
            <span class="turno-name">{{ t.label }}</span>
            <span class="turno-desc">
              <span class="turno-date">\{{ t.date }}</span>
              <span class="turno-age"></span>
              \{{ t.minAge }}-{{
                t.maxAge === 99 ? "99+" : t.maxAge
              }}
              anni</span
            >
            @if (getTurnoPrice(t.value); as price) {
              <span class="turno-price">{{ price }}</span>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Kit da portare -->
  <div class="content-section">
    <div class="program-card">
      <h2>Kit da<br />portare</h2>
      <div class="kit-grid">
        <div class="kit-item">Lenzuola singole</div>
        <div class="kit-item">Bagnoschiuma e shampoo</div>
        <div class="kit-item">Borraccia con nome e cognome</div>
        <div class="kit-item">Cambi completi vari</div>
        <div class="kit-item">Accappatoio o telo per doccia</div>
        <div class="kit-item">Ciabatte in gomma</div>
        <div class="kit-item">Repellente antizanzare</div>
        <div class="kit-item">Protezione solare</div>
        <div class="kit-item">Salviettine umidificate</div>
        <div class="kit-item">Fazzoletti</div>
      </div>
    </div>
  </div>

  <!-- Come raggiungerci -->
  <div class="content-section">
    <div class="program-card">
      <h2>Come<br />raggiungerci</h2>
      <div class="transport-sections">
        <div class="transport-mode">
          <h3 class="transport-mode-title">In aereo</h3>
          <div class="transport-routes">
            <div class="transport-route">
              <span class="route-badge orange">Milano-Malpensa MXP</span>
              <ol class="route-steps">
                <li>Malpensa Express → Milano Centrale (50 min)</li>
                <li>Treno regionale → Lodi (30 min)</li>
              </ol>
            </div>
            <div class="transport-route">
              <span class="route-badge blue">Milano-Bergamo BGY</span>
              <ol class="route-steps">
                <li>Bus → Bergamo Stazione (15 min)</li>
                <li>Treno per Milano Centrale (50 min)</li>
                <li>Treno regionale per Lodi (30 min)</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="transport-mode">
          <h3 class="transport-mode-title">In treno</h3>
          <div class="transport-routes">
            <div class="transport-route">
              <span class="route-badge green">Milano Centrale RFI</span>
              <ol class="route-steps">
                <li>Treno regionale → Lodi (30 min)</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="transport-mode">
          <h3 class="transport-mode-title">In auto</h3>
          <div class="transport-routes">
            <div class="transport-route">
              <span class="route-badge purple">Tramite A1 – uscita Lodi</span>
              <ol class="route-steps">
                <li>Prendi l'A1</li>
                <li>Uscita Lodi-Pieve Fissiraga</li>
                <li>Segui le indicazioni per il centro città (10 min)</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div class="location-badge">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path
            d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
          />
        </svg>
        <span>AREA DEL CAPANNO, LODI – VIA TARAMELLI</span>
      </div>
    </div>
  </div>

  <!-- Form Iscrizione -->
  <div class="registration-section">
    <div class="title">
      <h2>Modulo di Iscrizione</h2>
    </div>

    @if (isLoadingProducts) {
      <div class="loading-products">
        <p>Caricamento informazioni...</p>
      </div>
    } @else if (productsError) {
      <div class="products-error">
        <p>{{ productsError }}</p>
        <button type="button" class="retry-btn" (click)="loadProducts()">
          Riprova
        </button>
      </div>
    } @else {
      @if (isSuccess) {
        <div class="success-container">
          <div class="success-icon">&#10004;</div>
          <h3>Iscrizione Completata!</h3>
          <p>{{ successMessage }}</p>
          <button
            type="button"
            class="new-registration-btn"
            (click)="resetForm()"
          >
            Nuova Iscrizione
          </button>
        </div>
      } @else {
        <form class="registration-form" (ngSubmit)="onSubmit()">
          <!-- Step indicators -->
          <div class="step-indicators">
            <div
              class="step-indicator"
              [class.active]="currentStep >= 1"
              [class.current]="currentStep === 1"
            >
              <span class="step-number">1</span>
              <span class="step-label">Tipo</span>
            </div>
            <div class="step-line" [class.active]="currentStep >= 2"></div>
            <div
              class="step-indicator"
              [class.active]="currentStep >= 2"
              [class.current]="currentStep === 2"
            >
              <span class="step-number">2</span>
              <span class="step-label">Anagrafica</span>
            </div>
            <div class="step-line" [class.active]="currentStep >= 3"></div>
            <div
              class="step-indicator"
              [class.active]="currentStep >= 3"
              [class.current]="currentStep === 3"
            >
              <span class="step-number">3</span>
              <span class="step-label">Turno</span>
            </div>
            <div class="step-line" [class.active]="currentStep >= 4"></div>
            <div
              class="step-indicator"
              [class.active]="currentStep >= 4"
              [class.current]="currentStep === 4"
            >
              <span class="step-number">4</span>
              <span class="step-label">Sanitaria</span>
            </div>
            <div class="step-line" [class.active]="currentStep >= 5"></div>
            <div
              class="step-indicator"
              [class.active]="currentStep >= 5"
              [class.current]="currentStep === 5"
            >
              <span class="step-number">5</span>
              <span class="step-label">Documenti</span>
            </div>
            <div class="step-line" [class.active]="currentStep >= 6"></div>
            <div
              class="step-indicator"
              [class.active]="currentStep >= 6"
              [class.current]="currentStep === 6"
            >
              <span class="step-number">6</span>
              <span class="step-label">Consensi</span>
            </div>
          </div>

          <!-- STEP 1: Tipo Iscrizione -->
          @if (currentStep === 1) {
            <div class="section-title">Tipo di Iscrizione</div>

            <div class="form-group">
              <div class="cost-options">
                <label
                  class="cost-option"
                  [class.selected]="tipoIscrizione === 'adulto'"
                >
                  <input
                    type="radio"
                    name="tipoIscrizione"
                    value="adulto"
                    [(ngModel)]="tipoIscrizione"
                  />
                  <h3>Adulto</h3>
                  <p class="price-description">Maggiorenne</p>
                </label>

                <label
                  class="cost-option"
                  [class.selected]="tipoIscrizione === 'minore'"
                >
                  <input
                    type="radio"
                    name="tipoIscrizione"
                    value="minore"
                    [(ngModel)]="tipoIscrizione"
                  />
                  <h3>Minore</h3>
                  <p class="price-description">
                    Iscrizione a cura del genitore/tutore
                  </p>
                </label>
              </div>
            </div>

            <div class="form-navigation">
              <div></div>
              <button
                type="button"
                class="nav-btn next"
                [disabled]="!isStep1Valid()"
                (click)="nextStep()"
              >
                AVANTI
              </button>
            </div>
          }

          <!-- STEP 2: Dati Anagrafici -->
          @if (currentStep === 2) {
            @if (isMinore) {
              <div class="section-title">Dati del Genitore / Tutore</div>

              <div class="form-row">
                <div class="form-group">
                  <label for="cognomeGenitore">Cognome genitore *</label>
                  <input
                    type="text"
                    id="cognomeGenitore"
                    name="cognomeGenitore"
                    autocomplete="section-genitore family-name"
                    [(ngModel)]="cognomeGenitore"
                    placeholder="Cognome del genitore"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="nomeGenitore">Nome genitore *</label>
                  <input
                    type="text"
                    id="nomeGenitore"
                    name="nomeGenitore"
                    autocomplete="section-genitore given-name"
                    [(ngModel)]="nomeGenitore"
                    placeholder="Nome del genitore"
                    required
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label for="luogoNascitaGenitore">Luogo di nascita *</label>
                  <input
                    type="text"
                    id="luogoNascitaGenitore"
                    name="luogoNascitaGenitore"
                    autocomplete="section-genitore address-level2"
                    [(ngModel)]="luogoNascitaGenitore"
                    placeholder="Citta di nascita"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="dataNascitaGenitore">Data di nascita *</label>
                  <input
                    type="date"
                    id="dataNascitaGenitore"
                    name="dataNascitaGenitore"
                    autocomplete="section-genitore bday"
                    [(ngModel)]="dataNascitaGenitore"
                    required
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label for="residenzaGenitore">Residenza (comune) *</label>
                  <input
                    type="text"
                    id="residenzaGenitore"
                    name="residenzaGenitore"
                    autocomplete="section-genitore address-level2"
                    [(ngModel)]="residenzaGenitore"
                    placeholder="Comune di residenza"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="viaGenitore">Via *</label>
                  <input
                    type="text"
                    id="viaGenitore"
                    name="viaGenitore"
                    autocomplete="section-genitore street-address"
                    [(ngModel)]="viaGenitore"
                    placeholder="Via e numero civico"
                    required
                  />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label for="capGenitore">CAP *</label>
                  <input
                    type="text"
                    id="capGenitore"
                    name="capGenitore"
                    autocomplete="section-genitore postal-code"
                    [(ngModel)]="capGenitore"
                    placeholder="CAP"
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="emailGenitore">Email *</label>
                  <input
                    type="email"
                    id="emailGenitore"
                    name="emailGenitore"
                    autocomplete="section-genitore email"
                    [(ngModel)]="emailGenitore"
                    placeholder="email@esempio.it"
                    required
                  />
                </div>
              </div>

              <div class="section-title">Dati del Minore (partecipante)</div>
            } @else {
              <div class="section-title">Dati Anagrafici</div>
            }

            <div class="form-row">
              <div class="form-group">
                <label for="cognome">Cognome *</label>
                <input
                  type="text"
                  id="cognome"
                  name="cognome"
                  autocomplete="family-name"
                  [(ngModel)]="cognome"
                  placeholder="Cognome"
                  required
                />
              </div>
              <div class="form-group">
                <label for="nome">Nome *</label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  autocomplete="given-name"
                  [(ngModel)]="nome"
                  placeholder="Nome"
                  required
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="luogoNascita">Luogo di nascita *</label>
                <input
                  type="text"
                  id="luogoNascita"
                  name="luogoNascita"
                  autocomplete="address-level2"
                  [(ngModel)]="luogoNascita"
                  placeholder="Citta di nascita"
                  required
                />
              </div>
              <div class="form-group">
                <label for="dataNascita">Data di nascita *</label>
                <input
                  type="date"
                  id="dataNascita"
                  name="dataNascita"
                  autocomplete="bday"
                  [(ngModel)]="dataNascita"
                  required
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="residenza">Residenza (comune) *</label>
                <input
                  type="text"
                  id="residenza"
                  name="residenza"
                  autocomplete="address-level2"
                  [(ngModel)]="residenza"
                  placeholder="Comune di residenza"
                  required
                />
              </div>
              <div class="form-group">
                <label for="via">Via *</label>
                <input
                  type="text"
                  id="via"
                  name="via"
                  autocomplete="street-address"
                  [(ngModel)]="via"
                  placeholder="Via e numero civico"
                  required
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="cap">CAP *</label>
                <input
                  type="text"
                  id="cap"
                  name="cap"
                  autocomplete="postal-code"
                  [(ngModel)]="cap"
                  placeholder="CAP"
                  required
                />
              </div>
              <div class="form-group">
                <label for="codiceFiscale">Codice Fiscale *</label>
                <input
                  type="text"
                  id="codiceFiscale"
                  name="codiceFiscale"
                  [(ngModel)]="codiceFiscale"
                  placeholder="RSSMRA85M01H501Z"
                  required
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="telefono">Cellulare *</label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  autocomplete="tel"
                  [(ngModel)]="telefono"
                  placeholder="+39 123 456 7890"
                  required
                />
              </div>
              <div class="form-group"></div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  autocomplete="email"
                  [(ngModel)]="email"
                  placeholder="email@esempio.it"
                  required
                />
              </div>
              <div class="form-group">
                <label for="reperibilita">Reperibilita per emergenze *</label>
                <input
                  type="text"
                  id="reperibilita"
                  name="reperibilita"
                  [(ngModel)]="reperibilita"
                  placeholder="Recapito telefonico emergenze"
                  required
                />
              </div>
            </div>

            <div class="form-group">
              <label for="note">Note</label>
              <textarea
                id="note"
                name="note"
                [(ngModel)]="note"
                placeholder="Eventuali note o informazioni aggiuntive (es. iscrizione di gruppo, richieste particolari...)"
                rows="3"
              ></textarea>
            </div>

            <div class="form-navigation">
              <button type="button" class="nav-btn prev" (click)="prevStep()">
                INDIETRO
              </button>
              <button
                type="button"
                class="nav-btn next"
                [disabled]="!isStep2Valid()"
                (click)="nextStep()"
              >
                AVANTI
              </button>
            </div>
          }

          <!-- STEP 3: Scelta Turno (filtrato per eta) -->
          @if (currentStep === 3) {
            <div class="section-title">Scegli il Turno</div>

            @if (availableTurni.length === 0) {
              <div class="no-turni-message">
                <p>
                  Non ci sono turni disponibili per l'eta indicata (data di
                  nascita: {{ dataNascita }}).
                </p>
                <p>Torna indietro e verifica la data di nascita inserita.</p>
              </div>
            } @else {
              <p class="turno-filter-info">
                I turni mostrati sono quelli compatibili con l'eta del
                partecipante.
              </p>

              <div class="form-group">
                <div class="turni-options">
                  @for (t of availableTurni; track t.value) {
                    <label
                      class="turno-option"
                      [class.selected]="turno === t.value"
                    >
                      <input
                        type="radio"
                        name="turno"
                        [value]="t.value"
                        [(ngModel)]="turno"
                      />
                      <div class="turno-option-content">
                        <span class="turno-option-name">{{ t.label }}</span>
                        <span class="turno-option-date"
                          >{{ t.date }} ({{ t.minAge }}-{{
                            t.maxAge === 99 ? "99+" : t.maxAge
                          }}
                          anni)</span
                        >
                      </div>
                      @if (t.value === "children") {
                        <div class="turno-option-info">
                          <span class="turno-info-text"
                            >Turno diurno - Iscrizione senza pagamento
                            online</span
                          >
                        </div>
                      } @else if (t.value === "sorrisi-speciali") {
                        <div class="turno-option-info">
                          <span class="turno-info-text"
                            >Iscrizione con conferma - Colloquio richiesto</span
                          >
                        </div>
                      } @else {
                        @if (getTurnoProduct(t.value); as product) {
                          <div class="turno-option-price">
                            <span class="turno-deposit"
                              >Acconto:
                              {{ formatPrice(product.depositAmount) }}</span
                            >
                          </div>
                        }
                      }
                    </label>
                  }
                </div>
              </div>

              <!-- Riepilogo prezzo -->
              @if (turno) {
                @if (isChildrenTurno) {
                  <div class="info-summary">
                    <div class="info-box">
                      <h4>Turno Children - Diurno (senza pernottamento)</h4>
                      <p>
                        <strong>Costo:</strong> €15 al giorno + €5 quota
                        assicurazione (una tantum)
                      </p>
                      <p><strong>Include:</strong> Colazione, pranzo e cena</p>
                      <p class="highlight">
                        Non è richiesto il pagamento online. Procedi con
                        l'iscrizione e riceverai le istruzioni per il pagamento.
                      </p>
                    </div>
                  </div>
                } @else if (isSorrisiSpecialiTurno) {
                  <div class="info-summary">
                    <div class="info-box">
                      <h4>Turno Sorrisi Speciali</h4>
                      <p>
                        <strong>Turno dedicato:</strong> Per ragazzi con
                        disabilità o autismo
                      </p>
                      <p>
                        <strong>Include:</strong> Pernottamento in container
                      </p>
                      <p class="highlight">
                        Iscrizione soggetta a conferma. È richiesto un colloquio
                        preliminare. Non è necessario pagare l'acconto online.
                      </p>
                    </div>
                  </div>
                } @else if (selectedTurno) {
                  <div class="info-summary">
                    <div class="info-box">
                      <h4>
                        Turno {{ selectedTurno.label }} ({{
                          selectedTurno.date
                        }})
                      </h4>
                      <p>
                        <strong>Descrizione:</strong>
                        {{ selectedTurno.description }}
                      </p>
                      <p>
                        <strong>Include:</strong> Pernottamento in container
                      </p>
                    </div>
                  </div>
                  @if (selectedTurnoProduct) {
                    <div class="price-summary">
                      <div class="price-note">
                        La quota è calcolata come <strong>€15/notte</strong> +
                        <strong>€5 di assicurazione</strong> (una tantum per
                        turno) + <strong>€2 di commissione</strong>.
                      </div>
                      <div class="price-row">
                        <span
                          >Quota totale turno {{ selectedTurno.label }}</span
                        >
                        <span>{{ totalFormatted }}</span>
                      </div>
                      <div class="price-row deposit">
                        <span>Acconto - da pagare ora online</span>
                        <span>{{ depositFormatted }}</span>
                      </div>
                      <div class="price-row remaining">
                        <span
                          >Saldo restante - da pagare direttamente in sede</span
                        >
                        <span>{{ remainingFormatted }}</span>
                      </div>
                    </div>
                  }
                }
              }
            }

            <!-- Campi aggiuntivi Asaf -->
            @if (isAsafTurno) {
              <div class="section-title asaf-section-title">
                Informazioni per il turno Asaf
              </div>
              <p class="turno-filter-info">
                Il turno Asaf è dedicato a musicisti e adoratori. Compila i
                seguenti campi obbligatori.
              </p>

              <div class="form-group">
                <label for="strumentoAsaf"
                  >Canti o suoni qualche strumento? *</label
                >
                <input
                  type="text"
                  id="strumentoAsaf"
                  name="strumentoAsaf"
                  [(ngModel)]="strumentoAsaf"
                  placeholder="Es. Chitarra, Pianoforte, Voce..."
                  required
                />
              </div>

              <div class="form-group">
                <label for="motivazioneAsaf"
                  >Motivazione per l'iscrizione al campeggio *</label
                >
                <textarea
                  id="motivazioneAsaf"
                  name="motivazioneAsaf"
                  [(ngModel)]="motivazioneAsaf"
                  placeholder="Raccontaci brevemente perché vorresti partecipare al turno Asaf..."
                  rows="4"
                  required
                ></textarea>
              </div>
            }

            <div class="form-navigation">
              <button type="button" class="nav-btn prev" (click)="prevStep()">
                INDIETRO
              </button>
              <button
                type="button"
                class="nav-btn next"
                [disabled]="!isStep3Valid()"
                (click)="nextStep()"
              >
                AVANTI
              </button>
            </div>
          }

          <!-- STEP 4: Scheda Sanitaria -->
          @if (currentStep === 4) {
            <div class="section-title">
              Scheda Sanitaria{{ isMinore ? " del Minore" : "" }}
            </div>

            <div class="form-group">
              <label>Vaccinazione antitetanica *</label>
              <div class="radio-options-inline">
                <label
                  class="radio-option-inline"
                  [class.selected]="vaccinazioneAntitetanica === 'si'"
                >
                  <input
                    type="radio"
                    name="vaccinazioneAntitetanica"
                    value="si"
                    [(ngModel)]="vaccinazioneAntitetanica"
                  />
                  SI
                </label>
                <label
                  class="radio-option-inline"
                  [class.selected]="vaccinazioneAntitetanica === 'no'"
                >
                  <input
                    type="radio"
                    name="vaccinazioneAntitetanica"
                    value="no"
                    [(ngModel)]="vaccinazioneAntitetanica"
                  />
                  NO
                </label>
              </div>
            </div>

            <div class="form-group">
              <label for="allergie"
                >Effettive allergie e/o intolleranze a cibi</label
              >
              <textarea
                id="allergie"
                name="allergie"
                [(ngModel)]="allergie"
                placeholder="Indica eventuali allergie o intolleranze alimentari"
                rows="3"
              ></textarea>
            </div>

            <div class="form-group">
              <label for="farmaci">Eventuali farmaci assunti</label>
              <textarea
                id="farmaci"
                name="farmaci"
                [(ngModel)]="farmaci"
                placeholder="Indica eventuali farmaci assunti regolarmente"
                rows="3"
              ></textarea>
            </div>

            <div class="form-group">
              <label for="patologie">Patologie presenti</label>
              <textarea
                id="patologie"
                name="patologie"
                [(ngModel)]="patologie"
                placeholder="Indica eventuali patologie"
                rows="2"
              ></textarea>
            </div>

            <div class="form-group">
              <label for="noteSanitarie"
                >Ulteriori note sanitarie di rilievo</label
              >
              <textarea
                id="noteSanitarie"
                name="noteSanitarie"
                [(ngModel)]="noteSanitarie"
                placeholder="Altre informazioni sanitarie utili"
                rows="2"
              ></textarea>
            </div>

            <div class="form-navigation">
              <button type="button" class="nav-btn prev" (click)="prevStep()">
                INDIETRO
              </button>
              <button
                type="button"
                class="nav-btn next"
                [disabled]="!isStep4Valid()"
                (click)="nextStep()"
              >
                AVANTI
              </button>
            </div>
          }

          <!-- STEP 5: Documenti -->
          @if (currentStep === 5) {
            <div class="section-title">
              Documenti{{ isMinore ? " del Partecipante" : "" }}
            </div>

            <p class="document-info-text">
              Carica fronte e retro
              @if (isMinore) {
                della tessera sanitaria del partecipante (il documento
                d'identità è facoltativo).
              } @else {
                del documento d'identita e della tessera sanitaria.
              }
              Puoi scattare una foto direttamente dal telefono o caricare un
              file (JPG, PNG, WEBP, PDF - max 10MB).
            </p>

            <div class="document-row">
              <!-- Documento identita fronte -->
              <div class="document-upload-area">
                <label class="document-label"
                  >Documento d'identita (fronte){{
                    isMinore ? "" : " *"
                  }}</label
                >
                @if (uploadingSlot === "documentoIdentitaFronte") {
                  <div class="upload-status">
                    <div class="upload-spinner"></div>
                    <span>Caricamento...</span>
                  </div>
                } @else if (documentoIdentitaFronte) {
                  <div class="document-preview">
                    @if (
                      uploadPreviews["documentoIdentitaFronte"] &&
                      uploadPreviews["documentoIdentitaFronte"] !== "pdf"
                    ) {
                      <img
                        [src]="uploadPreviews['documentoIdentitaFronte']"
                        alt="Preview"
                      />
                    } @else {
                      <div class="pdf-icon">PDF</div>
                    }
                    <span class="document-filename">{{
                      uploadFilenames["documentoIdentitaFronte"]
                    }}</span>
                    <button
                      type="button"
                      class="remove-btn"
                      (click)="removeDocument('documentoIdentitaFronte')"
                    >
                      &times;
                    </button>
                  </div>
                } @else {
                  <button
                    type="button"
                    class="upload-btn file"
                    (click)="fileIdentitaFronte.click()"
                  >
                    Carica file
                  </button>
                  <input
                    #fileIdentitaFronte
                    type="file"
                    accept="image/*,application/pdf"
                    hidden
                    (change)="
                      onFileSelected(
                        $event,
                        'documentoIdentitaFronte',
                        'identita-fronte',
                        'partecipante'
                      )
                    "
                  />
                }
                @if (uploadErrors["documentoIdentitaFronte"]) {
                  <div class="document-error">
                    {{ uploadErrors["documentoIdentitaFronte"] }}
                  </div>
                }
              </div>

              <!-- Documento identita retro -->
              <div class="document-upload-area">
                <label class="document-label"
                  >Documento d'identita (retro){{ isMinore ? "" : " *" }}</label
                >
                @if (uploadingSlot === "documentoIdentitaRetro") {
                  <div class="upload-status">
                    <div class="upload-spinner"></div>
                    <span>Caricamento...</span>
                  </div>
                } @else if (documentoIdentitaRetro) {
                  <div class="document-preview">
                    @if (
                      uploadPreviews["documentoIdentitaRetro"] &&
                      uploadPreviews["documentoIdentitaRetro"] !== "pdf"
                    ) {
                      <img
                        [src]="uploadPreviews['documentoIdentitaRetro']"
                        alt="Preview"
                      />
                    } @else {
                      <div class="pdf-icon">PDF</div>
                    }
                    <span class="document-filename">{{
                      uploadFilenames["documentoIdentitaRetro"]
                    }}</span>
                    <button
                      type="button"
                      class="remove-btn"
                      (click)="removeDocument('documentoIdentitaRetro')"
                    >
                      &times;
                    </button>
                  </div>
                } @else {
                  <button
                    type="button"
                    class="upload-btn file"
                    (click)="fileIdentitaRetro.click()"
                  >
                    Carica file
                  </button>
                  <input
                    #fileIdentitaRetro
                    type="file"
                    accept="image/*,application/pdf"
                    hidden
                    (change)="
                      onFileSelected(
                        $event,
                        'documentoIdentitaRetro',
                        'identita-retro',
                        'partecipante'
                      )
                    "
                  />
                }
                @if (uploadErrors["documentoIdentitaRetro"]) {
                  <div class="document-error">
                    {{ uploadErrors["documentoIdentitaRetro"] }}
                  </div>
                }
              </div>
            </div>

            <div class="document-row">
              <!-- Tessera sanitaria fronte -->
              <div class="document-upload-area">
                <label class="document-label"
                  >Tessera sanitaria (fronte) *</label
                >
                @if (uploadingSlot === "tesseraSanitariaFronte") {
                  <div class="upload-status">
                    <div class="upload-spinner"></div>
                    <span>Caricamento...</span>
                  </div>
                } @else if (tesseraSanitariaFronte) {
                  <div class="document-preview">
                    @if (
                      uploadPreviews["tesseraSanitariaFronte"] &&
                      uploadPreviews["tesseraSanitariaFronte"] !== "pdf"
                    ) {
                      <img
                        [src]="uploadPreviews['tesseraSanitariaFronte']"
                        alt="Preview"
                      />
                    } @else {
                      <div class="pdf-icon">PDF</div>
                    }
                    <span class="document-filename">{{
                      uploadFilenames["tesseraSanitariaFronte"]
                    }}</span>
                    <button
                      type="button"
                      class="remove-btn"
                      (click)="removeDocument('tesseraSanitariaFronte')"
                    >
                      &times;
                    </button>
                  </div>
                } @else {
                  <button
                    type="button"
                    class="upload-btn file"
                    (click)="fileTesseraFronte.click()"
                  >
                    Carica file
                  </button>
                  <input
                    #fileTesseraFronte
                    type="file"
                    accept="image/*,application/pdf"
                    hidden
                    (change)="
                      onFileSelected(
                        $event,
                        'tesseraSanitariaFronte',
                        'tessera-fronte',
                        'partecipante'
                      )
                    "
                  />
                }
                @if (uploadErrors["tesseraSanitariaFronte"]) {
                  <div class="document-error">
                    {{ uploadErrors["tesseraSanitariaFronte"] }}
                  </div>
                }
              </div>

              <!-- Tessera sanitaria retro -->
              <div class="document-upload-area">
                <label class="document-label"
                  >Tessera sanitaria (retro) *</label
                >
                @if (uploadingSlot === "tesseraSanitariaRetro") {
                  <div class="upload-status">
                    <div class="upload-spinner"></div>
                    <span>Caricamento...</span>
                  </div>
                } @else if (tesseraSanitariaRetro) {
                  <div class="document-preview">
                    @if (
                      uploadPreviews["tesseraSanitariaRetro"] &&
                      uploadPreviews["tesseraSanitariaRetro"] !== "pdf"
                    ) {
                      <img
                        [src]="uploadPreviews['tesseraSanitariaRetro']"
                        alt="Preview"
                      />
                    } @else {
                      <div class="pdf-icon">PDF</div>
                    }
                    <span class="document-filename">{{
                      uploadFilenames["tesseraSanitariaRetro"]
                    }}</span>
                    <button
                      type="button"
                      class="remove-btn"
                      (click)="removeDocument('tesseraSanitariaRetro')"
                    >
                      &times;
                    </button>
                  </div>
                } @else {
                  <button
                    type="button"
                    class="upload-btn file"
                    (click)="fileTesseraRetro.click()"
                  >
                    Carica file
                  </button>
                  <input
                    #fileTesseraRetro
                    type="file"
                    accept="image/*,application/pdf"
                    hidden
                    (change)="
                      onFileSelected(
                        $event,
                        'tesseraSanitariaRetro',
                        'tessera-retro',
                        'partecipante'
                      )
                    "
                  />
                }
                @if (uploadErrors["tesseraSanitariaRetro"]) {
                  <div class="document-error">
                    {{ uploadErrors["tesseraSanitariaRetro"] }}
                  </div>
                }
              </div>
            </div>

            <!-- Documenti Genitore (solo minore) -->
            @if (isMinore) {
              <div class="section-title">Documenti del Genitore / Tutore</div>

              <div class="document-row">
                <!-- Documento identita fronte genitore -->
                <div class="document-upload-area">
                  <label class="document-label"
                    >Documento d'identita (fronte) *</label
                  >
                  @if (uploadingSlot === "documentoIdentitaFronteGenitore") {
                    <div class="upload-status">
                      <div class="upload-spinner"></div>
                      <span>Caricamento...</span>
                    </div>
                  } @else if (documentoIdentitaFronteGenitore) {
                    <div class="document-preview">
                      @if (
                        uploadPreviews["documentoIdentitaFronteGenitore"] &&
                        uploadPreviews["documentoIdentitaFronteGenitore"] !==
                          "pdf"
                      ) {
                        <img
                          [src]="
                            uploadPreviews['documentoIdentitaFronteGenitore']
                          "
                          alt="Preview"
                        />
                      } @else {
                        <div class="pdf-icon">PDF</div>
                      }
                      <span class="document-filename">{{
                        uploadFilenames["documentoIdentitaFronteGenitore"]
                      }}</span>
                      <button
                        type="button"
                        class="remove-btn"
                        (click)="
                          removeDocument('documentoIdentitaFronteGenitore')
                        "
                      >
                        &times;
                      </button>
                    </div>
                  } @else {
                    <button
                      type="button"
                      class="upload-btn file"
                      (click)="fileIdentitaFronteGen.click()"
                    >
                      Carica file
                    </button>
                    <input
                      #fileIdentitaFronteGen
                      type="file"
                      accept="image/*,application/pdf"
                      hidden
                      (change)="
                        onFileSelected(
                          $event,
                          'documentoIdentitaFronteGenitore',
                          'identita-fronte',
                          'genitore'
                        )
                      "
                    />
                  }
                  @if (uploadErrors["documentoIdentitaFronteGenitore"]) {
                    <div class="document-error">
                      {{ uploadErrors["documentoIdentitaFronteGenitore"] }}
                    </div>
                  }
                </div>

                <!-- Documento identita retro genitore -->
                <div class="document-upload-area">
                  <label class="document-label"
                    >Documento d'identita (retro) *</label
                  >
                  @if (uploadingSlot === "documentoIdentitaRetroGenitore") {
                    <div class="upload-status">
                      <div class="upload-spinner"></div>
                      <span>Caricamento...</span>
                    </div>
                  } @else if (documentoIdentitaRetroGenitore) {
                    <div class="document-preview">
                      @if (
                        uploadPreviews["documentoIdentitaRetroGenitore"] &&
                        uploadPreviews["documentoIdentitaRetroGenitore"] !==
                          "pdf"
                      ) {
                        <img
                          [src]="
                            uploadPreviews['documentoIdentitaRetroGenitore']
                          "
                          alt="Preview"
                        />
                      } @else {
                        <div class="pdf-icon">PDF</div>
                      }
                      <span class="document-filename">{{
                        uploadFilenames["documentoIdentitaRetroGenitore"]
                      }}</span>
                      <button
                        type="button"
                        class="remove-btn"
                        (click)="
                          removeDocument('documentoIdentitaRetroGenitore')
                        "
                      >
                        &times;
                      </button>
                    </div>
                  } @else {
                    <button
                      type="button"
                      class="upload-btn file"
                      (click)="fileIdentitaRetroGen.click()"
                    >
                      Carica file
                    </button>
                    <input
                      #fileIdentitaRetroGen
                      type="file"
                      accept="image/*,application/pdf"
                      hidden
                      (change)="
                        onFileSelected(
                          $event,
                          'documentoIdentitaRetroGenitore',
                          'identita-retro',
                          'genitore'
                        )
                      "
                    />
                  }
                  @if (uploadErrors["documentoIdentitaRetroGenitore"]) {
                    <div class="document-error">
                      {{ uploadErrors["documentoIdentitaRetroGenitore"] }}
                    </div>
                  }
                </div>
              </div>

              <div class="document-row">
                <!-- Tessera sanitaria fronte genitore -->
                <div class="document-upload-area">
                  <label class="document-label"
                    >Tessera sanitaria (fronte) *</label
                  >
                  @if (uploadingSlot === "tesseraSanitariaFronteGenitore") {
                    <div class="upload-status">
                      <div class="upload-spinner"></div>
                      <span>Caricamento...</span>
                    </div>
                  } @else if (tesseraSanitariaFronteGenitore) {
                    <div class="document-preview">
                      @if (
                        uploadPreviews["tesseraSanitariaFronteGenitore"] &&
                        uploadPreviews["tesseraSanitariaFronteGenitore"] !==
                          "pdf"
                      ) {
                        <img
                          [src]="
                            uploadPreviews['tesseraSanitariaFronteGenitore']
                          "
                          alt="Preview"
                        />
                      } @else {
                        <div class="pdf-icon">PDF</div>
                      }
                      <span class="document-filename">{{
                        uploadFilenames["tesseraSanitariaFronteGenitore"]
                      }}</span>
                      <button
                        type="button"
                        class="remove-btn"
                        (click)="
                          removeDocument('tesseraSanitariaFronteGenitore')
                        "
                      >
                        &times;
                      </button>
                    </div>
                  } @else {
                    <button
                      type="button"
                      class="upload-btn file"
                      (click)="fileTesseraFronteGen.click()"
                    >
                      Carica file
                    </button>
                    <input
                      #fileTesseraFronteGen
                      type="file"
                      accept="image/*,application/pdf"
                      hidden
                      (change)="
                        onFileSelected(
                          $event,
                          'tesseraSanitariaFronteGenitore',
                          'tessera-fronte',
                          'genitore'
                        )
                      "
                    />
                  }
                  @if (uploadErrors["tesseraSanitariaFronteGenitore"]) {
                    <div class="document-error">
                      {{ uploadErrors["tesseraSanitariaFronteGenitore"] }}
                    </div>
                  }
                </div>

                <!-- Tessera sanitaria retro genitore -->
                <div class="document-upload-area">
                  <label class="document-label"
                    >Tessera sanitaria (retro) *</label
                  >
                  @if (uploadingSlot === "tesseraSanitariaRetroGenitore") {
                    <div class="upload-status">
                      <div class="upload-spinner"></div>
                      <span>Caricamento...</span>
                    </div>
                  } @else if (tesseraSanitariaRetroGenitore) {
                    <div class="document-preview">
                      @if (
                        uploadPreviews["tesseraSanitariaRetroGenitore"] &&
                        uploadPreviews["tesseraSanitariaRetroGenitore"] !==
                          "pdf"
                      ) {
                        <img
                          [src]="
                            uploadPreviews['tesseraSanitariaRetroGenitore']
                          "
                          alt="Preview"
                        />
                      } @else {
                        <div class="pdf-icon">PDF</div>
                      }
                      <span class="document-filename">{{
                        uploadFilenames["tesseraSanitariaRetroGenitore"]
                      }}</span>
                      <button
                        type="button"
                        class="remove-btn"
                        (click)="
                          removeDocument('tesseraSanitariaRetroGenitore')
                        "
                      >
                        &times;
                      </button>
                    </div>
                  } @else {
                    <button
                      type="button"
                      class="upload-btn file"
                      (click)="fileTesseraRetroGen.click()"
                    >
                      Carica file
                    </button>
                    <input
                      #fileTesseraRetroGen
                      type="file"
                      accept="image/*,application/pdf"
                      hidden
                      (change)="
                        onFileSelected(
                          $event,
                          'tesseraSanitariaRetroGenitore',
                          'tessera-retro',
                          'genitore'
                        )
                      "
                    />
                  }
                  @if (uploadErrors["tesseraSanitariaRetroGenitore"]) {
                    <div class="document-error">
                      {{ uploadErrors["tesseraSanitariaRetroGenitore"] }}
                    </div>
                  }
                </div>
              </div>
            }

            <div class="form-navigation">
              <button type="button" class="nav-btn prev" (click)="prevStep()">
                INDIETRO
              </button>
              <button
                type="button"
                class="nav-btn next"
                [disabled]="!isStep5Valid() || isAnyUploading"
                (click)="nextStep()"
              >
                AVANTI
              </button>
            </div>
          }

          <!-- STEP 6: Consensi e Pagamento -->
          @if (currentStep === 6) {
            <div class="section-title">Consenso Foto e Video</div>

            <p class="consent-text">
              Durante le attivita potranno essere effettuate riprese
              fotografiche o filmati{{
                isMinore ? " che ritraggono il minore" : ""
              }}
              per un'eventuale diffusione sui social
              (WhatsApp/Facebook/Instagram/YouTube)
            </p>

            <div class="form-group">
              <div class="cost-options">
                <label
                  class="cost-option small"
                  [class.selected]="consensoSocial === 'si'"
                >
                  <input
                    type="radio"
                    name="consensoSocial"
                    value="si"
                    [(ngModel)]="consensoSocial"
                  />
                  <h3>Do il consenso</h3>
                </label>
                <label
                  class="cost-option small"
                  [class.selected]="consensoSocial === 'no'"
                >
                  <input
                    type="radio"
                    name="consensoSocial"
                    value="no"
                    [(ngModel)]="consensoSocial"
                  />
                  <h3>Non do il consenso</h3>
                </label>
              </div>
            </div>

            <div class="section-title">Trattamento Dati Personali</div>

            <div class="form-group privacy-section">
              <p class="privacy-text">
                Ai sensi dell'art. 13 del Regolamento Europeo 2016/679 (GDPR),
                l'Associazione Come Tralci fornisce l'informativa sul
                trattamento dei dati personali.
                <a href="javascript:void(0)" (click)="openPrivacyDialog()"
                  >Leggi l'informativa completa</a
                >.
              </p>

              <div class="consent-checkboxes">
                <label class="privacy-checkbox">
                  <input
                    type="checkbox"
                    name="consensoTrattamentoDati"
                    [(ngModel)]="consensoTrattamentoDati"
                  />
                  <b>ACCONSENTO</b> al trattamento dei
                  {{
                    isMinore
                      ? "miei dati personali e di mio/a figlio/a"
                      : "miei dati personali"
                  }}
                  (ivi compresi i dati sensibili) nei limiti indicati
                  nell'informativa stessa, al punto "2-a" e limitatamente agli
                  scopi da essa previsti. *
                </label>

                <label class="privacy-checkbox">
                  <input
                    type="checkbox"
                    name="consensoDiffusioneDati"
                    [(ngModel)]="consensoDiffusioneDati"
                  />
                  <b>ACCONSENTO</b> alla diffusione dei dati personali per le
                  finalita indicate nell'informativa stessa, al punto "2-a", e
                  limitatamente agli scopi da essa previsti. *
                </label>

                <label class="privacy-checkbox">
                  <input
                    type="checkbox"
                    name="consensoPromozione"
                    [(ngModel)]="consensoPromozione"
                  />
                  <b>ACCONSENTO</b> al trattamento dei dati personali per le
                  finalita di comunicazione o promozione commerciale previste
                  dal punto "2-c" dell'informativa, ivi compresa la
                  comunicazione dei dati stessi ai soggetti indicati, per tali
                  finalita, al punto 5. (facoltativo)
                </label>
              </div>
            </div>

            <div class="section-title">Trattamento Dati Sanitari</div>

            <div class="form-group privacy-section">
              <p class="privacy-text">
                Autorizzo il trattamento dei dati personali, comuni e sensibili,
                ai sensi del Regolamento Europeo 679/2016 ("GDPR") e del decreto
                attuativo 10.08.2018, n. 101. Dichiaro che i dati sanitari
                indicati sono aggiornati, veritieri, completi e compatibili con
                l'attivita dell'iniziativa.
              </p>
              <label class="privacy-checkbox">
                <input
                  type="checkbox"
                  name="consensoTrattamentoDatiSanitari"
                  [(ngModel)]="consensoTrattamentoDatiSanitari"
                />
                <b>ACCONSENTO</b> al trattamento dei dati sanitari
                {{ isMinore ? "del minore" : "" }} *
              </label>
            </div>

            <div class="section-title">
              Dichiarazione e Assunzione di Responsabilità
            </div>

            <div class="form-group privacy-section">
              <div class="privacy-text declaration-text">
                <p>
                  @if (isMinore) {
                    Il/la sottoscritto/a
                    <strong>{{ cognomeGenitore }} {{ nomeGenitore }}</strong
                    >, in qualità di genitore/tutore di
                    <strong>{{ cognome }} {{ nome }}</strong
                    >,
                  } @else {
                    Il/la sottoscritto/a
                    <strong>{{ cognome }} {{ nome }}</strong>
                  }
                  dichiara di essere a conoscenza degli obiettivi educativi ed
                  evangelistici dell'iniziativa (divulgazione degli insegnamenti
                  cristiani desunti dalla Bibbia, trasmissione dei valori
                  cristiani, prevenzione della devianza giovanile,
                  intrattenimento ludico per ragazzi e giovani, volontariato
                  sociale missionario).
                </p>

                <p>
                  @if (isMinore) {
                    Sono consapevole che:
                  } @else {
                    Sono consapevole che:
                  }
                </p>
                <ul>
                  <li>
                    dette attività verranno attuate in conformità ai principi di
                    educazione alla vita cristiana;
                  </li>
                  <li>
                    @if (isMinore) {
                      mio/a figlio/a parteciperà a giochi di attività fisica
                      all'aperto;
                    } @else {
                      parteciperò a giochi di attività fisica all'aperto;
                    }
                  </li>
                  <li>
                    la Fondazione non risponderà dai danni
                    @if (isMinore) {
                      causati dal/dalla minore
                    } @else {
                      da me causati
                    }
                    a persone o cose durante le attività.
                  </li>
                </ul>

                <p><strong>DICHIARO</strong></p>
                <ol>
                  <li>
                    @if (isMinore) {
                      che il/la minore parteciperà alle attività di cui sopra in
                      piena consapevolezza e con piena fiducia nell'operato
                      degli organizzatori;
                    } @else {
                      che parteciperò alle attività di cui sopra in piena
                      consapevolezza e con piena fiducia nell'operato degli
                      organizzatori;
                    }
                  </li>
                  <li>
                    di sollevare gli organizzatori ed il Consiglio Direttivo da
                    eventuali responsabilità connesse al normale svolgimento
                    delle attività;
                  </li>
                  <li>
                    di esonerare e sollevare da ogni responsabilità la
                    Fondazione Beth-Shalom APS ed il suo legale rappresentante,
                    nonché il personale addetto alle attività svolte da ogni
                    responsabilità civile e penale, anche oggettiva, derivante
                    dalla
                    @if (isMinore) {
                      partecipazione del/della minore
                    } @else {
                      mia partecipazione
                    }
                    alle attività svolte, nonché dalla permanenza e soggiorno
                    nei locali ove le attività della fondazione si svolgeranno,
                    in caso di eventuali incidenti o infortuni
                    @if (isMinore) {
                      dallo/a stesso/a
                    } @else {
                      dallo/a stesso/a
                    }
                    personalmente subiti ovvero cagionati a terzi nel corso
                    dell'espletamento delle attività svolte e/o da svolgere;
                  </li>
                  <li>
                    di esonerare e sollevare da ogni responsabilità la
                    Fondazione Beth-Shalom APS ed il suo legale rappresentante,
                    nonché il personale addetto alle attività svolte da
                    qualsiasi ipotesi di responsabilità per danni subiti e/o
                    @if (isMinore) {
                      prodotti dal/dalla minore
                    } @else {
                      da me prodotti
                    }
                    a cose proprie della Fondazione Beth-Shalom APS e/o di terzi
                    a causa dello svolgimento dei suoi interventi e/o delle sue
                    prestazioni con espressa esclusione, altresì, di ogni
                    facoltà di azione surrogatoria
                    @if (isMinore) {
                      da parte nostra
                    } @else {
                      da parte mia
                    }
                    e/o di qualsiasi altro nostro/mio avente causa;
                  </li>
                  <li>
                    di rinunciare a qualsiasi richiesta di risarcimento e di
                    rimborso presenti o che
                    @if (isMinore) {
                      potremmo
                    } @else {
                      potremmo
                    }
                    rivendicare in futuro nei confronti della Fondazione
                    Beth-Shalom APS e del suo legale rappresentante nonché degli
                    operatori/volontari etc. e dalle relative azioni giudiziarie
                    (cause e qualsivoglia tipo di procedimento giudiziario e/o
                    arbitrale) con esonero della Fondazione Beth-Shalom APS da
                    ogni responsabilità e da tutte le azioni ad essa relative al
                    rischio d'infortuni, risarcimento di danni a persone e/o
                    cose di terzi, danneggiamenti alle attrezzature e al rischio
                    di smarrimenti d'effetti personali per furto o qualsivoglia
                    ragione.
                  </li>
                </ol>

                <p>
                  @if (isMinore) {
                    Dichiaro che il/la minore non prenderà iniziative personali
                    senza consultare i Responsabili.
                  } @else {
                    Dichiaro di non prendere iniziative personali senza
                    consultare i Responsabili.
                  }
                </p>
              </div>

              <label class="privacy-checkbox">
                <input
                  type="checkbox"
                  name="consensoEsonero"
                  [(ngModel)]="consensoEsonero"
                />
                <b>ACCETTO</b> integralmente la dichiarazione di esonero e
                assunzione di responsabilità sopra riportata. *
              </label>
            </div>

            <div class="section-title">Gruppo WhatsApp</div>

            <div class="form-group privacy-section">
              <p class="privacy-text">
                Autorizzo l'inserimento del mio numero di telefono all'interno
                del gruppo WhatsApp dedicato al turno selezionato, per
                comunicazioni organizzative relative alle attività del campo.
              </p>
              <label class="privacy-checkbox">
                <input
                  type="checkbox"
                  name="consensoWhatsapp"
                  [(ngModel)]="consensoWhatsapp"
                />
                <b>AUTORIZZO</b> l'inserimento del mio numero nel gruppo
                WhatsApp dedicato.
              </label>
            </div>

            <!-- Riepilogo pagamento -->
            @if (turno) {
              @if (isChildrenTurno) {
                <div class="section-title">Riepilogo Iscrizione</div>
                <div class="info-summary">
                  <div class="info-box">
                    <h4>Turno Children - Diurno ({{ selectedTurno?.date }})</h4>
                    <p>
                      <strong>Costo:</strong> €15 al giorno + €5 quota
                      assicurazione (una tantum) + €2 di commissione
                    </p>
                    <p>
                      <strong>Include:</strong> Colazione, pranzo e cena (senza
                      pernottamento)
                    </p>
                    <p class="highlight">
                      Procedi con l'invio dell'iscrizione. Riceverai istruzioni
                      per il pagamento via email.
                    </p>
                  </div>
                </div>
              } @else if (isSorrisiSpecialiTurno) {
                <div class="section-title">Riepilogo Iscrizione</div>
                <div class="info-summary">
                  <div class="info-box">
                    <h4>Turno Sorrisi Speciali ({{ selectedTurno?.date }})</h4>
                    <p>
                      <strong>Turno dedicato:</strong> Per ragazzi con
                      disabilità o autismo
                    </p>
                    <p><strong>Include:</strong> Pernottamento in container</p>
                    <p class="highlight">
                      La tua iscrizione verrà inviata e sarà sottoposta a
                      revisione. Verrai contattato per un colloquio preliminare
                      e per ricevere conferma e dettagli sul pagamento.
                    </p>
                  </div>
                </div>
              } @else if (selectedTurno) {
                <div class="section-title">Riepilogo Pagamento</div>
                <div class="info-summary">
                  <div class="info-box">
                    <h4>
                      Turno {{ selectedTurno.label }} ({{ selectedTurno.date }})
                    </h4>
                    <p>
                      <strong>Descrizione:</strong>
                      {{ selectedTurno.description }}
                    </p>
                    <p><strong>Include:</strong> Pernottamento in container</p>
                  </div>
                </div>
                @if (selectedTurnoProduct) {
                  <div class="price-summary">
                    <div class="price-note">
                      La quota è calcolata come <strong>€15/giorno</strong> +
                      <strong>€5 di assicurazione</strong> (una tantum per
                      turno).
                    </div>
                    <div class="price-row">
                      <span
                        >Quota totale turno {{ selectedTurno.label }} ({{
                          selectedTurno.date
                        }})</span
                      >
                      <span>{{ totalFormatted }}</span>
                    </div>
                    <div class="price-row deposit highlight">
                      <span>Acconto - da pagare ora online</span>
                      <span>{{ depositFormatted }}</span>
                    </div>
                    <div class="price-row remaining">
                      <span
                        >Saldo restante - da pagare direttamente in sede</span
                      >
                      <span>{{ remainingFormatted }}</span>
                    </div>
                  </div>
                }
              }
            }

            <div class="form-navigation">
              <button type="button" class="nav-btn prev" (click)="prevStep()">
                INDIETRO
              </button>
              <button
                type="submit"
                class="submit-btn"
                [disabled]="!isFormValid() || isSubmitting"
              >
                @if (isSubmitting) {
                  @if (requiresPayment) {
                    REINDIRIZZAMENTO AL PAGAMENTO...
                  } @else {
                    INVIO ISCRIZIONE IN CORSO...
                  }
                } @else {
                  @if (requiresPayment) {
                    PROCEDI AL PAGAMENTO - {{ depositFormatted }}
                  } @else {
                    INVIA ISCRIZIONE
                  }
                }
              </button>
            </div>

            @if (errorMessage) {
              <div class="message error-message">
                {{ errorMessage }}
                @if (canRetry) {
                  <button
                    type="button"
                    class="retry-btn"
                    (click)="retryPayment()"
                  >
                    Riprova
                  </button>
                }
              </div>
            }
          }
        </form>
      }
    }
  </div>

  <!-- WhatsApp Help Button -->
  @if (showWhatsappBtn) {
    <div class="whatsapp-fab" [class.with-tooltip]="!whatsappTooltipDismissed">
      @if (!whatsappTooltipDismissed) {
        <div class="whatsapp-tooltip" (click)="whatsappTooltipDismissed = true">
          Hai bisogno di aiuto?
          <span class="tooltip-close">&times;</span>
        </div>
      }
      <a
        [href]="whatsappUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="whatsapp-btn"
        aria-label="Contattaci su WhatsApp"
      >
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.004 2.002C8.27 2.002 2 8.272 2 16.005c0 2.473.645 4.89 1.871 7.02L2 30l7.168-1.88A13.95 13.95 0 0 0 16.004 30C23.736 30 30 23.73 30 15.997 30 8.264 23.736 2.002 16.004 2.002Zm0 25.504a11.45 11.45 0 0 1-5.847-1.596l-.418-.248-4.338 1.137 1.158-4.226-.273-.434a11.4 11.4 0 0 1-1.75-6.134c0-6.334 5.155-11.489 11.49-11.489 6.334 0 11.488 5.155 11.488 11.49 0 6.333-5.176 11.5-11.51 11.5Zm6.303-8.604c-.345-.173-2.043-1.008-2.36-1.123-.317-.115-.548-.173-.779.173-.23.345-.893 1.123-1.095 1.354-.201.23-.403.26-.748.086-.345-.173-1.457-.536-2.775-1.712-1.025-.915-1.718-2.045-1.92-2.39-.2-.346-.02-.533.152-.705.155-.155.345-.403.518-.605.173-.201.23-.345.346-.576.115-.23.057-.432-.03-.605-.086-.173-.778-1.877-1.066-2.57-.28-.674-.565-.583-.778-.594l-.663-.011c-.23 0-.605.086-.922.432-.316.345-1.21 1.182-1.21 2.882s1.239 3.344 1.412 3.574c.173.23 2.44 3.725 5.912 5.224.826.357 1.47.57 1.972.729.829.264 1.583.226 2.18.137.665-.1 2.044-.836 2.332-1.643.288-.807.288-1.498.201-1.643-.086-.144-.316-.23-.662-.403Z"
            fill="#fff"
          />
        </svg>
      </a>
    </div>
  }

  <!-- Privacy Dialog -->
  @if (showPrivacyDialog) {
    <div class="privacy-dialog-overlay" (click)="closePrivacyDialog()">
      <div class="privacy-dialog" (click)="$event.stopPropagation()">
        <div class="privacy-dialog-header">
          <h3>Informativa Privacy – Campeggio Estivo</h3>
          <button
            type="button"
            class="privacy-dialog-close"
            (click)="closePrivacyDialog()"
          >
            &times;
          </button>
        </div>
        <div class="privacy-dialog-content">
          <section class="privacy-policy">
            <h1>INFORMATIVA PRIVACY – CAMPEGGIO ESTIVO</h1>
            <p><em>(ai sensi degli artt. 13 Reg. UE 2016/679 – GDPR)</em></p>

            <h2>1. Titolare del trattamento</h2>
            <p>
              Chiese Cristiane Evangeliche Pentecostali e Missionarie Come
              Tralci (o, in forma abbreviata, "Come Tralci" o anche "C.T.C."),
              Borgo San Giovanni (LO), via Enrico Fermi snc., CAP 26851, in
              persona del legale rappresentante pro tempore Gennaro Chiocca.
              <br />Contatti: e-mail
              <a href="mailto:info.chiese@cometralci.com"
                >info.chiese&#64;cometralci.com</a
              >
              – tel.
              <a href="tel:+390371977626">0371 977 626</a>.
            </p>

            <h2>2. Tipologie di dati trattati</h2>
            <p>
              L'Associazione Come Tralci tratta i seguenti dati personali
              relativi al minore e al genitore/tutore:
            </p>
            <ul>
              <li>
                <strong>Dati comuni identificativi</strong> (tra cui c.i. e
                tessera sanitaria), e di contatto: nome, cognome, data e luogo
                di nascita, indirizzo di residenza, numero di cellulare, e-mail;
              </li>
              <li>
                <strong>Dati di pagamento:</strong> importo versato, modalità di
                pagamento, estremi della transazione, eventuale IBAN o
                riferimento contabile. (Il Titolare non tratta direttamente i
                dati completi della carta di credito, che sono gestiti dal
                provider di pagamento come titolare autonomo);
              </li>
              <li>
                <strong>Dati particolari</strong> (ex art. 9 GDPR):
                <ol>
                  <li>
                    Dati particolari relativi alla salute: informazioni su
                    allergie, intolleranze, patologie, certificati medici,
                    terapie farmacologiche;
                  </li>
                  <li>
                    Eventuali dati idonei a rivelare convinzioni religiose,
                    desumibili dalla partecipazione alle attività educative e
                    formative di ispirazione cristiana;
                  </li>
                </ol>
              </li>
              <li>
                <strong>Immagini, foto e video:</strong> raccolti durante le
                attività educative/ricreative, solo previo consenso.
              </li>
            </ul>

            <h2>3. Finalità e basi giuridiche del trattamento</h2>
            <p>
              Le diverse tipologie di dati saranno trattate per le finalità di
              seguito indicate:
            </p>
            <ul>
              <li>
                Per i <strong>dati comuni identificativi</strong> (tra cui c.i.
                e tessera sanitaria), si persegue la finalità di gestione
                dell'iscrizione e partecipazione del minore alle attività
                educative, ludiche e ricreative. La base giuridica la si
                rinviene nell'art. 6.1.b del GDPR (esecuzione di un
                contratto/rapporto associativo), il conferimento di questa
                categoria di dati ha natura obbligatoria in quanto il rifiuto
                impedisce la partecipazione del minore alle attività;
              </li>
              <li>
                Per i <strong>dati di pagamento</strong> si persegue la finalità
                di gestione della quota di partecipazione, incasso acconti e
                saldi, gestione eventuali rimborsi, adempimenti fiscali e
                contabili, eventuali contestazioni o contenziosi. La base
                giuridica è da rinvenirsi negli Artt. 6, par. 1, lett. b) GDPR
                (esecuzione del contratto di partecipazione) e, 6, par. 1, lett.
                c) GDPR (adempimento di obblighi legali in materia fiscale e
                contabile). Il conferimento dei dati di pagamento è necessario
                per perfezionare l'iscrizione.
              </li>
              <li>
                Per la
                <strong
                  >gestione delle comunicazioni organizzative e urgenti</strong
                >
                con il partecipante (se maggiorenne), i genitori/tutori (es.
                variazioni di orari, avvisi, emergenze) potrà essere utilizzata
                la piattaforma di messaggistica WhatsApp, previo consenso
                all'utilizzo del numero di telefono cellulare per tale finalità.
                L'utilizzo del numero di telefono si fonda sull'art. 6, par. 1,
                lett. a) GDPR (consenso esplicito) e, l'uso dell'app WhatsApp
                Standard implica un trasferimento dei dati verso Paesi extra UE,
                effettuato ai sensi dell'art. 49, par. 1, lett. a) GDPR
                (consenso esplicito). Il consenso è facoltativo e il mancato
                rilascio non pregiudica la partecipazione alle attività:
                verranno utilizzati canali alternativi (SMS/e-mail).
              </li>
              <li>
                Per i <strong>dati particolari relativi alla salute</strong>
                (allergie, intolleranze, patologie, terapie farmacologiche) si
                persegue la finalità di tutela della salute e della sicurezza
                del minore durante le attività e, se necessario, anche la
                gestione di interventi sanitari di emergenza. Quanto alle basi
                giuridiche:
                <ul>
                  <li>
                    art. 6, par. 1, lett. b) GDPR (necessità di esecuzione del
                    rapporto associativo, in quanto i dati sono indispensabili
                    per garantire lo svolgimento sicuro delle attività);
                  </li>
                  <li>
                    art. 9, par. 2, lett. d) GDPR (trattamento effettuato,
                    nell'ambito delle legittime attività e con adeguate
                    garanzie, da un'associazione religiosa senza scopo di lucro
                    e nei confronti dei soli partecipanti alle iniziative);
                  </li>
                  <li>
                    art. 9, par. 2, lett. c) GDPR (in caso di emergenza
                    sanitaria, per salvaguardare l'interesse vitale del minore
                    mediante comunicazione dei dati a personale medico o
                    autorità competenti).
                  </li>
                </ul>
                Il conferimento è facoltativo, ma la mancata comunicazione può
                comportare l'impossibilità oggettiva di garantire condizioni di
                sicurezza e quindi la partecipazione del minore alle attività.
              </li>
              <li>
                Per i
                <strong
                  >dati particolari relativi alle convinzioni religiose</strong
                >
                si persegue la finalità di adempimento delle finalità
                istituzionali dell'ente religioso (istruzione e formazione
                cristiana ad indirizzo missionario). Tali dati sono raccolti
                esclusivamente per tale scopo e non saranno diffusi all'esterno.
                La base giuridica è da rinvenirsi nell'Art. 9, paragrafo 2,
                lettera d) del GDPR.
              </li>
              <li>
                Per la <strong>diffusione di immagini, foto e video</strong> del
                minore o del partecipante maggiorenne sui canali social e sul
                sito istituzionale dell'associazione Come Tralci (es. Facebook,
                Instagram, YouTube, sito web), la base giuridica è l'art. 6,
                par. 1, lett. a) GDPR, ossia il consenso esplicito del
                genitore/tutore. Il consenso è facoltativo e il suo mancato
                rilascio non pregiudica in alcun modo la partecipazione del
                minore alle attività.
              </li>
            </ul>

            <h2>4. Modalità del trattamento</h2>
            <p>
              Il trattamento sarà effettuato sia con strumenti cartacei che con
              strumenti elettronici e/o automatizzati, nel rispetto dei principi
              di liceità, correttezza, trasparenza e minimizzazione dei dati
              (Art. 5 GDPR), adottando misure di sicurezza tecniche e
              organizzative adeguate a garantire un livello di sicurezza
              appropriato al rischio.
            </p>

            <h2>5. Destinatari dei dati</h2>
            <p>
              I dati raccolti potranno essere comunicati ai seguenti soggetti,
              ognuno inquadrato secondo il proprio ruolo ai sensi del
              Regolamento (UE) 2016/679:
            </p>
            <ol>
              <li>
                Soggetti autorizzati al trattamento (personale, educatori,
                volontari di Come Tralci) che operano sotto l'autorità diretta
                del Titolare e vincolati all'obbligo di segretezza;
              </li>
              <li>
                Autorità Giudiziarie, Forze di Polizia o Enti Pubblici per
                adempimenti di obblighi di legge o su richiesta formale;
              </li>
              <li>Compagnie Assicurative per la gestione di sinistri;</li>
              <li>
                Soggetti che agiscono come Responsabili Esterni del Trattamento
                (ex Art. 28 GDPR), ai quali il Titolare si affida per
                l'esecuzione di specifici servizi tecnici e organizzativi. Tali
                soggetti sono nominati formalmente tramite un accordo.
              </li>
              <li>
                Soggetti che agiranno in qualità di titolari autonomi come ad
                esempio, psicoterapeuti, avvocati e medici, qualora i dati dei
                minori (inclusi i dati relativi a situazioni di vulnerabilità o
                salute) debbano essere comunicati per motivi di tutela,
                assistenza sanitaria, diagnosi o difesa in sede giudiziaria
                (Art. 9, par. 2, lett. f, h, i GDPR).
              </li>
            </ol>

            <h3>
              Specifiche sulla Collaborazione con la Fondazione BETH SHALOM
            </h3>
            <p>
              In ragione del vincolo istituzionale e per l'adempimento delle
              finalità statutarie dell'Associazione Come Tralci — specificamente
              quelle relative al sostegno, alla tutela e al supporto di persone
              in situazioni di vulnerabilità e fragilità sociale — si
              rappresenta che la Fondazione BETH SHALOM potrà essere
              destinataria dei dati personali (ivi inclusi dati particolari come
              la situazione di vulnerabilità) secondo due ruoli distinti, a
              seconda dell'attività specifica svolta:
            </p>
            <p>
              <strong
                >a) Per le attività di coordinamento ordinario e
                logistica:</strong
              >
            </p>
            <ul>
              <li>Ruolo: Responsabile del Trattamento (ex Art. 28 GDPR)</li>
              <li>
                Finalità: La comunicazione avviene per il coordinamento delle
                attività, la gestione della logistica, l'organizzazione degli
                spazi e dei servizi condivisi, sulla base dell'Art. 6.1.b GDPR
                (Esecuzione del rapporto associativo).
              </li>
            </ul>
            <p>
              <strong
                >b) Per l'attivazione di percorsi di tutela e assistenza
                sociale:</strong
              >
            </p>
            <ul>
              <li>Ruolo: Titolare Autonomo del Trattamento.</li>
              <li>
                Finalità: La comunicazione avviene solo in caso di emersione,
                durante l'attività, di gravi situazioni di fragilità sociale
                (es. indigenza, problematiche socio-psicologiche, rischio per
                l'incolumità, sospetto di abuso/pedofilia, violenza).
              </li>
              <li>
                Base Giuridica: La comunicazione dei dati a BETH SHALOM avviene,
                nei casi strettamente necessari, sulla base di:
                <ul>
                  <li>
                    Art. 6, par. 1, lett. f) GDPR (legittimo interesse alla
                    tutela del minore);
                  </li>
                  <li>
                    Art. 9, par. 2, lett. c) GDPR (tutela di interessi vitali);
                  </li>
                  <li>
                    Art. 9, par. 2, lett. d) GDPR (attività legittime di enti
                    senza scopo di lucro).
                  </li>
                </ul>
              </li>
            </ul>
            <p>
              La comunicazione è limitata ai soli dati indispensabili per
              l'attivazione degli interventi di tutela. BETH SHALOM procede
              autonomamente, per fini istituzionali, all'intervento
              specialistico a tutela del minore. In questo caso, BETH SHALOM
              risponderà autonomamente dell'ulteriore trattamento.
            </p>
            <p>
              I dati non saranno diffusi né ceduti a terzi per finalità
              commerciali.
            </p>

            <h2>6. Trasferimenti extra UE</h2>
            <p>
              L'utilizzo della piattaforma WhatsApp Standard comporta il
              trasferimento dei dati verso Meta Platforms Inc. (USA). Il
              trasferimento avviene sulla base delle condizioni contrattuali del
              provider e, ove necessario, ai sensi dell'art. 49, par. 1, lett.
              a) GDPR. Il mancato consenso non comporta alcun pregiudizio:
              saranno utilizzati canali alternativi (SMS/e-mail).
            </p>

            <h2>7. Periodo di conservazione</h2>
            <ul>
              <li>
                I dati identificativi e di contatto saranno conservati per la
                durata dell'iniziativa e per i successivi 24 mesi, salvo
                obblighi di legge o contenziosi in corso;
              </li>
              <li>
                I dati contabili e relativi ai pagamenti saranno conservati per
                10 anni ai sensi della normativa civilistica e fiscale vigente.
              </li>
              <li>
                I dati relativi alla salute saranno conservati solo per la
                durata dell'iniziativa e cancellati nel termine di 12 mesi (un
                anno) dall'ultima partecipazione del minore, al fine di
                agevolare la ripresa della partecipazione dopo assenze
                temporanee o l'iscrizione per il ciclo di attività successivo,
                salvo diversa richiesta di cancellazione da parte dell'esercente
                la responsabilità genitoriale.
              </li>
              <li>
                I dati relativi alle convinzioni religiose (ex Art. 9 GDPR)
                saranno conservati per l'intera durata della partecipazione del
                minore all'iniziativa e, successivamente, per un periodo massimo
                di 5 anni dalla cessazione del rapporto. Tale periodo è
                necessario per adempiere agli obblighi di documentazione interna
                relativi alle finalità istituzionali e per la gestione di
                eventuali contenziosi legali o accertamenti amministrativi.
                Trascorso tale periodo, i dati saranno cancellati o resi
                anonimi, salvo esigenze di archiviazione storica documentate.
              </li>
              <li>
                Le immagini/video saranno conservate fino alla revoca del
                consenso o per un periodo massimo di 5 anni dalla raccolta. Tale
                periodo massimo è giustificato dalla necessità di utilizzare il
                materiale per documentare e promuovere le future edizioni
                annuali dell'iniziativa. Sono fatte salve le esigenze di
                archiviazione storica debitamente giustificate, per le quali i
                dati saranno conservati separatamente e con misure di sicurezza
                specifiche.
              </li>
            </ul>

            <h2>8. Diritti degli interessati</h2>
            <p>
              In qualità di Interessato (o come esercente la responsabilità
              genitoriale per il minore), Lei ha il diritto di esercitare i
              diritti previsti dagli artt. 15-22 del GDPR, in particolare:
            </p>
            <ul>
              <li>
                <strong>Diritto di Accesso</strong> (Art. 15): ottenere conferma
                che sia in corso un trattamento di dati e, in tal caso,
                accedervi.
              </li>
              <li>
                <strong>Diritto di Rettifica</strong> (Art. 16): ottenere la
                correzione dei dati inesatti.
              </li>
              <li>
                <strong
                  >Diritto alla Cancellazione ("Diritto all'Oblio")</strong
                >
                (Art. 17): ottenere la cancellazione dei dati, se ne ricorrono i
                presupposti legali.
              </li>
              <li>
                <strong>Diritto di Limitazione di Trattamento</strong> (Art.
                18): limitare il trattamento in determinate circostanze.
              </li>
              <li>
                <strong>Diritto alla Portabilità dei Dati</strong> (Art. 20):
                ricevere i dati in un formato strutturato, di uso comune e
                leggibile da dispositivo automatico.
              </li>
              <li>
                <strong>Diritto di Opposizione</strong> (Art. 21): opporsi al
                trattamento per motivi legittimi.
              </li>
              <li>
                <strong>Diritto di Revoca del Consenso</strong> (Art. 7):
                revocare in qualsiasi momento il consenso eventualmente fornito,
                senza pregiudicare la liceità del trattamento basata sul
                consenso prima della revoca.
              </li>
            </ul>
            <p>
              Tali diritti possono essere esercitati inviando una richiesta
              scritta ai recapiti del Titolare (punto 1).
            </p>

            <h2>9. Obbligatorietà del conferimento</h2>
            <p>
              Sussiste l'obbligo di conferimento per i dati comuni
              identificativi (Art. 6.1.b GDPR), in quanto necessari per la
              gestione e le comunicazioni urgenti. Per quanto riguarda i dati
              relativi a immagini/foto/video, e il numero di cellulare per
              l'utilizzo di WhatsApp, rimangono facoltativi e subordinati a
              consenso. Per quanto riguarda i dati particolari relativi alla
              salute, il loro conferimento non è obbligatorio, ma è strettamente
              necessario per garantire la partecipazione in condizioni di
              sicurezza: la mancata comunicazione preclude la partecipazione
              stessa del minore alle attività. Analogamente, il conferimento dei
              dati relativi alle convinzioni religiose è necessario per
              l'adempimento delle finalità istituzionali dell'ente religioso
              (Art. 9.2.d GDPR).
            </p>

            <h2>10. Diritto di Reclamo</h2>
            <p>
              Qualora ritenga che il trattamento dei dati che La riguardano
              violi il Regolamento, Lei ha il Diritto di Proporre Reclamo
              all'Autorità di Controllo come previsto dall'Art. 77 GDPR (<a
                href="https://www.garanteprivacy.it"
                target="_blank"
                rel="noopener noreferrer"
                >www.garanteprivacy.it</a
              >).
            </p>
          </section>
        </div>
        <div class="privacy-dialog-footer">
          <button
            type="button"
            class="privacy-dialog-btn confirm"
            (click)="closePrivacyDialog()"
          >
            CHIUDI
          </button>
        </div>
      </div>
    </div>
  }
</div>
